// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"289":"8200154c","787":"64ffeffc"}[chunkId] + ".chunk.js";
};